import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const procurementSpendWidget: DashboardWidgetConfiguration = {
  widgetId: "procurement.spend",
  name: "Purchase spend",
  description: "Purchase spend for the selected dashboard period.",
  apps: [
    "home",
    "procurement",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "procurement.purchases",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "total",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Purchase spend",
    subtext: "in the last 30 days",
    icon: "money",
    color: "danger",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$92,750",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
